import {
  CalendarDaysIcon,
  ChevronRightIcon,
} from "@heroicons/react/24/outline";
import Datepicker from "flowbite-datepicker/Datepicker";
import React, { useEffect, useMemo, useState } from "react";
import JobTable, { RupeeCell, StatusPill } from "../../table/JobTable";
import { BASE_URL_2 } from "../../../customHooks/config";
import axios from "axios";
import { toast } from "react-toastify";

function History() {
  const [rows, setRows] = useState([]);
  const [filter, setFilter] = useState({});
  // const [data,setData] = useState([]);
  const [paginationData, setPaginationData] = useState({
    pageSize: 5,
    pageNumber: 1,
    next: false,
    previous: false,
    count: 0,
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    let url = `${BASE_URL_2}job/vendor/raised_request/?page_size=${paginationData?.pageSize}&page=${paginationData?.pageNumber}`;
    if (filter?.stages?.param)
      url = `${BASE_URL_2}job/vendor/raised_request/?page_size=${paginationData?.pageSize}&page=${paginationData?.pageNumber}`;

    axios
      .get(url, { withCredentials: true })
      .then((res) => {
        const nums = res?.data?.data;
        setRows(nums?.results);
        setPaginationData({
          ...paginationData,
          count: nums?.count,
          next: nums?.next ? true : false,
          previous: nums?.previous ? true : false,
        });
        setLoading(false);
      })
      .catch((err) => {
        toast.error(err?.data?.error);
        setLoading(false);
      });
  }, [paginationData.pageNumber, paginationData.pageSize, filter]);

  const columns = useMemo(
    () => [
      {
        Header: "Request ID",
        width: 100,
        accessor: "request_id",
      },
      {
        Header: "Request date & time",
        width: 150,
        accessor: "request_date_time",
      },
      {
        Header: "Request amount",
        width: 120,
        Cell: RupeeCell,
        accessor: "request_amount",
      },
      {
        Header: "Update date & time",
        width: 200,
        accessor: "update_date_time",
      },
      {
        Header: "Approved by",
        width: 120,
        accessor: "approved_by",
        Cell: ({ row }) =>
          `${row?.original?.approved_by?.first_name} ${row?.original?.approved_by?.last_name}`,
      },

      {
        Header: "Stages",
        width: 100,
        Cell: ({ row }) => (
          <>
            <StatusPill value={row?.original?.status} />
          </>
        ),
        accessor: "stages",
      },
    ],
    []
  );

  return (
    <>
      <div
        className="absolute top-[72px] mt-[5px] "
        style={{ fontFamily: "gilRoy-semibold" }}
      >
        <nav className="flex" aria-label="Breadcrumb">
          <ol className="inline-flex items-center space-x-1 md:space-x-3">
            <li className="inline-flex items-center">
              <a
                href="/my-earning"
                className="inline-flex items-center text-xs font-medium text-[#6C757D] hover:text-blue-600 "
              >
                My Earning
              </a>
            </li>
            <li style={{ marginLeft: 0 }}>
              <div className="flex items-center">
                <ChevronRightIcon className="w-3 h-3" />

                <a
                  href=""
                  className=" text-xs font-medium  text-[#6C757D] hover:text-blue-600"
                >
                  History
                </a>
              </div>
            </li>
          </ol>
        </nav>
      </div>

      <div className=" w-full flex  flex-col relative pt-4">
        <div className=" w-full flex justify-between items-center">
          <div className="mr-4">
            <h2 className="text-lg  font-bold ">History</h2>
          </div>
          <div className="w-[200px]">
            <div className="relative w-full  ">
              <input
                // datepicker
                // datepicker-autohide
                type="date"
                placeholder="Date"
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
                id="date"
                className=" mt-0 mb-0 border bg-white border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  "
              />
              {/* <div className="flex absolute inset-y-0 right-0 items-center pr-3 pointer-events-none cursor-pointer">
                <CalendarDaysIcon className="w-5 h-5 text-gray-500 cursor-pointer " />
              </div> */}
            </div>
          </div>
        </div>

        <div className="mt-7">
          <JobTable
            columns={columns}
            data={rows}
            paginationData={paginationData}
            setPaginationData={setPaginationData}
            pagination="pagination"
            loading={loading}
            tableWidth="w-full"
          />
        </div>
      </div>
    </>
  );
}

export default History;
